import axios from "axios";

class UserService {
    getPublicContent() {
        return axios.get(`/users/all`);
    }

    getUserBoard() {
        return axios.get(`/users/user`);
    }

    getAdminBoard() {
        return axios.get(`/users/admin`);
    }

    getMessages() {
        return axios.get("/users/all-messages");
    }

    createMessage(data) {
        return axios.post("/users/create-message", data);
    }

    deleteMessage(id) {
        return axios.delete(`/users/delete-message/${id}`);
    }

    changePass(data) {
        return axios.post("/auth/changePass", data);
    }

    changeEmail(data) {
        return axios.post("/admin/changeEmail", data);
    }

    changeUsername(data) {
        return axios.post("/admin/changeUsername", data);
    }

    requestPassChange(data) {
        return axios.post("/auth/requestPassChange", data);
    }

    checkValidPassChange(data) {
        return axios.post("/auth/checkValidPassChange", data);
    }

    toggleTeamChange(data) {
        return axios.post("/users/toggleTeamChange", data);
    }

    changeStatus(data) {
        return axios.post("/users/changeStatus", data);
    }

    agreeToTerms(data) {
        return axios.post("/users/agreeToTerms", data);
    }

    findAllUsers() {
        return axios.get("/users/find-users");
    }

    updatePersonalInformation(data) {
        return axios.post("/users/updatePersonalInformation", data);
    }

    verifyAuth() {
        return axios.get("/users/verify-auth");
    }

    checkUser(data) {
        return axios.get("/users/check-user?id=" + data);
    }

    updateInvoiceNumber(data) {
        return axios.post("/users/updateInvoiceNumber", data);
    }
}

export default new UserService();